module.exports = __webpack_public_path__ + "img/ring_g_e_1_null@3x.e9e15750.png";